import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));


const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
				width: 100
			  },	
		  '&:nth-child(2)': {
			width: 350
		  },
		  '&:nth-child(3)': {
			width: 250
		  },
		  '&:nth-child(4)': {
			width: 250
		  },
		  '&:nth-child(5)': {
			width: 200,
		  },
		}
	  }
	}
  });


const PurchaseOrderWholesaleTransactionHistory = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno')); //jc_user_id_no //branchidno

	// Data Fetching
	useEffect(() => {
		dataFilter();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'get_promo_transaction_history_wholesale', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_u_idno: useridNo,  
            }
        }).then((res)=>{
			setPosts(res.data.data);
			setDataLoaded(true);
		}).catch((error)=>{
			// console.log(error.message);
		})


    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "id",
			label: "ID",
		},
		{
			name: "trandate",
			label: "Date",
		},
		{
			name: "idno",
			label: "ID No",
			  options: {
			customBodyRender: (value) => {
			return value ? value : "—";
			}
			}
		},
		{
			name: "packagesalestype",
			label: "Account Type Name",
		},
		{
			name: "hqidno",
			label: "Purchase From",
		},
		{
			name: "packagestatus",
			label: "Status",
		},
		{
			name: "rcvall",
			label:"Action",
			options: { 
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let rcvall =  posts[dataIndex].rcvall;
					let pono =  posts[dataIndex].id;
					if(rcvall !== "No Delivery"){
						return(
							<Grid container spacing={1}>
								<Grid item xs={6}>
									<NavLink to={"/purchases/purchases-order-wholesale-view/"+pono+"/"+useridNo}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									   </NavLink> 
								</Grid>
							</Grid>
						)
					}
				},
				download: false //exclude this column in csv export
			}
		}
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'POTransactionHistory.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

	const style = {
		marginBottom: '1rem',
		marginTop:"1.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order Wholesale Set Transaction History</h4>
			</div>
			<div className="page-container">
				<div style={style}>

					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "22px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'user id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}
						<Grid item xs={1} xl={1}>
							<Button style ={{marginTop: "22px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>

					</Grid>       

				</div>

				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Purchase Order Wholesale Set Transaction History
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				  </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default PurchaseOrderWholesaleTransactionHistory;
